import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "quick-contact-container" }
const _hoisted_2 = {
  key: 0,
  class: "success-overlay rounded-4 p-4"
}

import { ref, onMounted, watch } from 'vue';
  import { useRoute } from 'vue-router';
  import ContactForm from "@/components/general/ContactForm.vue";
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'QuickContactWidget',
  setup(__props) {

  const formSuccess = ref(false);

  const route = useRoute();
  const showPopup = ref(false);

  const hasBeenManuallyClosed = ref(false);

  const togglePopup = () => {
      if (showPopup.value) {
          hasBeenManuallyClosed.value = true;
      }
      showPopup.value = !showPopup.value;
  };

  // Auto-open logic
  let autoOpenTimer: number;

  const startAutoOpen = () => {
      clearTimeout(autoOpenTimer);
      
      if (route.path.startsWith('/services')) {
          autoOpenTimer = setTimeout(() => {
              showPopup.value = true;
          }, 7000);
      }
  };

  onMounted(() => {
      startAutoOpen();
  });

  watch(() => route.path, () => {
      showPopup.value = false;
      startAutoOpen();
  });
  
  const onFormSubmitted = (isSuccess: boolean) => {
    if (isSuccess) {
      formSuccess.value = true;
    }
  };
  
  const closeSuccess = () => {
      formSuccess.value = false;
      showPopup.value = false;
  }
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: togglePopup,
      class: _normalizeClass(["contact-button btn rounded-circle p-3 shadow-sm border", { 'is-active': showPopup.value, 'glass-effect': true }]),
      "aria-label": "Open quick contact form"
    }, [
      _createElementVNode("i", {
        class: _normalizeClass(showPopup.value ? 'fas fa-times' : 'fas fa-comment-dots')
      }, null, 2)
    ], 2),
    _createVNode(_Transition, { name: "slide-up-fade" }, {
      default: _withCtx(() => [
        (showPopup.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["contact-popup shadow-xl rounded-4 p-4", { 'glass-effect': true }])
            }, [
              _createVNode(ContactForm, {
                isPopup: true,
                onFormSubmitted: onFormSubmitted
              }),
              _createElementVNode("i", {
                class: "close-icon fas fa-times",
                onClick: togglePopup
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (formSuccess.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "text-success pb-2" }, [
                _createElementVNode("i", { class: "fas fa-check-circle me-2" }),
                _createTextVNode("Success!")
              ], -1)),
              _cache[1] || (_cache[1] = _createElementVNode("p", { class: "small text-muted" }, "Thank you! We've received your enquiry and will be in touch shortly.", -1)),
              _createElementVNode("button", {
                onClick: closeSuccess,
                class: "btn btn-sm btn-outline-dark mt-3"
              }, "Close")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})